import React from "react";
import PropTypes from "prop-types";
import { Colours } from "@learningblocks/shared-components";
import { ORIENTATION } from "./AnimationBlocks.utils";
import ContentLoader from "react-content-loader";

export function AnimationBlockLoader(props) {
  let viewbox = "0 0 1 1";
  if (props.orientation === ORIENTATION.WIDE) viewbox = "0 0 16 9";

  return (
    <div aria-hidden="true">
      <ContentLoader
        speed={props.speed}
        viewBox={viewbox}
        style={props.style}
        backgroundColor={Colours.colorPrimary}
        foregroundColor="#3997dc"
      >
        <rect x="0" y="0" rx="0" ry="0" width="100%" height="100%" />
      </ContentLoader>
    </div>
  );
}

AnimationBlockLoader.propTypes = {
  /**
   * Style object with the height & width property for
   * component
   */
  style: PropTypes.object,
  /**
   * Orientation for Animation
   */
  orientation: PropTypes.oneOf(["wide", "square"]).isRequired,
  /**
   * Speed of animation
   */
  speed: PropTypes.number,
};

AnimationBlockLoader.defaultProps = {
  style: {},
  orientation: "square",
  speed: 2,
};
